export enum LANGUAGES {
	en = 'en',
	ru = 'ru',
}
